<template>
  <div class="description">Who will have schedules for booking during this event?
  <br/>You can have schedules for teachers, teams or both.<br/>You can always tweak this later.</div>
  <div>
    <v-checkbox
      class="custom-input custom-checkbox mt-3"
      label="Include All Teachers"
      v-model="wizard.allTeachers"
      :disabled="wizard.loading"
      data-cy="wizard-add-all-teachers"
    ></v-checkbox>
    <v-checkbox
      class="custom-input custom-checkbox"
      label="Include All Teams"
      v-model="wizard.allTeams"
      :disabled="wizard.loading"
      data-cy="wizard-add-all-teams"
    ></v-checkbox>
  </div>
</template>

<script setup lang="ts">
import useWizard from "@/stores/school/wizard";

const wizard = useWizard();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
